import React from "react";
import PropTypes from "prop-types";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import { Flex } from "@theme-ui/components";
import { colors } from "../../styles/theme";

const StarRating = ({ rating, color, fontSize, justifyContent, customStyles }) => {
  const renderStars = () => {
    const generateStarComponent = (index, type) => {
      const marginLeft = index === 1 ? "0" : "0.625rem";
      switch (type) {
        case "full":
          return <FaStar style={{ color, marginLeft }} key={`star${index}`} />;
        case "half":
          return (
            <FaStarHalfAlt style={{ color, marginLeft }} key={`star${index}`} />
          );
        case "empty":
        default:
          return (
            <FaRegStar style={{ color, marginLeft }} key={`star${index}`} />
          );
      }
    };

    const stars = [];

    for (let i = 1; i <= 5; i++) {
      if (i <= Math.floor(rating)) {
        stars.push(generateStarComponent(i, "full"));
      } else if (i === Math.ceil(rating) && !Number.isInteger(rating)) {
        stars.push(generateStarComponent(i, "half"));
      } else {
        stars.push(generateStarComponent(i, "empty"));
      }
    }

    return stars;
  };

  return <Flex sx={{ fontSize, justifyContent, minWidth: "8.438rem", ...customStyles }}>{renderStars()}</Flex>;
};

StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
  color: PropTypes.string,
  fontSize: PropTypes.string,
  justifyContent: PropTypes.string,
};

StarRating.defaultProps = {
  color: colors.secondaryOrange500,
  fontSize: "1.188rem",
  justifyContent: "flex-end",
};

export default StarRating;
